import { getLocalizedStrings } from '../profileSettingsLocalizedStrings';
import classes from './notificationSettings.scss';
import EmailPreferences from './Presentational/emailPreferences';
import TextBox from "./Presentational/newMailText";
import NotificationVoiceSettings from './notificationVoiceSettingsContainer';
import ErrorCard from '../Common/errCard';
import ViewAllEmail from './viewAllEmail';
import ViewAllVoice from './viewAllVoice';
import TwoFactorAuthContainer from '../Common/TwoFactorAuthentication/twoFactorAuthContainer';
class NotificationSettings extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      editmail:false,Editbutton:false,viewallemails:false,viewallphones:false,viewallvoices:false,closemodal:false,showEmailToolTip:false,editButtonPress:false,cancelButtonPress:false,addIconPress:false,saveCancelButtonPress:false,inputEmail:"",addError:false,isNewEmailValid:"",enteredEmail:"",editEmail:"",emailExistErrMsg:"",modifyError:"",addressGuid:"",reqObj:{},addFlag:"",deleteFlag:"",saveCall:"",newMail:"",emailIds:[],oldEmailIds:[],voice:[],text:[],addContactToggleStatus: { 'email': false, 'voice': false, 'text': false },preferenceError:[],disabledAdd:true, isEmailInvalid:false,emailErr:false,lastEAPreference:false,emailPrefErr:false,removeEmail:'',paperlessEnrolled:false,addEmailExistErrMsg:'',msCallErr:false,viewAllMail:false,accountObj: [],disabledSave:"",duplicatePhoneList: new Map(),
      twoFactorAuthentication: { isEmail: false, isPhone: false, userEnteredValue: '', showModal: '',changeFlag:'',encryptedvalue:'', seqNo:'', phoneTypeSelectionEdit:'', bpNumber:'', duplicateNumber: ''}
    };
    this.strings = getLocalizedStrings('NotificationSettings'), this.mainBpNumber='', this.CACTCount='',
    this.emailIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg',  this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg',this.removeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Remove.svg', this.editIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/editIcon.svg',this.textIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg', this.voiceIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg',this.warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg', this.initialPositionValue = window.getComputedStyle(document.body).position;
  }
  componentWillMount(){
    let userGroup = app.appService.getPrioritisedUserGrp();
    userGroup === app.appUtil.getAppConstants().USER_GROUPS.MYACCOUNT || userGroup === app.appUtil.getAppConstants().USER_GROUPS.GUESTUSERS  ? this.getAccountUserDetails() : this.getWebUserDetails();}
getAccountUserDetails=()=>{
  if(app.appService.isAuthenticated() || app.appService.isCpcGuestUser()){
    let accountData = app.appService.getUserInfo().profileData.accountData;
    let isValidBPNumber = !_.isEmpty(accountData);
    this.mainBpNumber = (isValidBPNumber && accountData.mainBusinessPartner !==null) ? accountData.mainBusinessPartner.businessPartnerNumber :null;
    if(this.mainBpNumber !==null){
      this.refreshNotification();
    }else{
      this.props.bPNumberFound(false);}}}
  toolTipKeyPress= (e) =>{
    if(e.key === "Enter"){
      this.setState({showEmailToolTip:!this.state.showEmailToolTip});}}
    getWebUserDetails = () => {
      app.profileSettingsService.getWebUserDetails(app.appService.getUserInfo().profileData.profile).then((response) => {
          if (response.errorCode !== undefined && response.errorCode !== ''){ 
            this.props.webUser(false,null);
          }else{
            this.mainBpNumber=response.getBusinessPartnerInformationResponse.results[0].businessPartnerNumber;
            this.refreshNotification();
            this.props.webUser(true,this.mainBpNumber);
          }});}
  refreshNotification(){
    app.profileSettingsService.getNotificationDetails(this.mainBpNumber).then((response) => {
      if (response.errorCode !== undefined && response.errorCode !== '') {
        this.setState({emailIds: '', msCallErr:true });}
      else{
        app.appService.setSessionstorage('customerPreferenceData', response);
        let list = response.phoneNumbers.filter(record => record.indicatorSmsEnabled === 'X');
        this.CACTCount=response.contractAccountCount;
        let userInfo = app.appService.getUserInfo();
        if(app.appService.isAuthenticated() && app.appService.getPrioritisedUserGrp() === app.appUtil.getAppConstants().USER_GROUPS.MYACCOUNT && response.contractAccountCount === "1" || "0"){
          let acctType = userInfo.accountType;}
        else if (this.CACTCount>1){
          let acctType= app.appUtil.getAppConstants().MY_ACCOUNT.ACCOUNT_TYPE_MULTI;}
       else {
        let acctType= this.CACTCount==="1" ? app.appUtil.getAppConstants().MY_ACCOUNT.ACCOUNT_TYPE_SINGLE: app.appUtil.getAppConstants().MY_ACCOUNT.ACCOUNT_TYPE_MULTI;
          app.analyticsService.addPageLevelData('accountType', acctType, '');
          window.aUtils.sendAAEvent('accountType', acctType);}
        this.setState({text :list,emailIds: response.emailAddresses,voice: response.phoneNumbers,addressGuid:response.addressGuid,msCallErr:false, duplicatePhoneList: response.duplicatePhoneList});
      } });}
  getEnrollDetails(bpNumber,email){
   
    app.profileSettingsService.getEnrollDetails(bpNumber,email,"INT").then((response) => {
      if (response.errorCode !== undefined && response.errorCode !== '') {
        //err
      } else {
        this.setPreference(response.impactedDevice, response.lastEAPreference);//impactedpreferences
      
        if(this.state.preferenceError.length>0 && this.state.removeEmail ){
    
        this.setState({emailErr:true}) ;}
      if(this.state.preferenceError.length>0 && this.state.editEmail){
    
          this.setState({emailPrefErr:true}) ;}
     
      } });}
  setPreference(preferences, lastEAPreference) {
    const updatedState = { ...this.state };
    updatedState.preferenceError = [];
    updatedState.lastEAPreference = lastEAPreference;
    if(lastEAPreference && this.state.removeEmail){
      updatedState.preferenceError.push('Emergency Alerts');} 
    else {
    preferences.map((preference) => {
      if (preference.category === 'DEMR' && preference.messageType === 'CPP1') {
        updatedState.preferenceError.push('Critical Peak Pricing Notifications');//string to preference
      } else if (preference.category === 'PROG' && preference.messageType === 'BUDA') {
        updatedState.preferenceError.push('Budget Assistance Notifications');}
      else if (preference.category === 'PAPR' && preference.messageType === 'EBIL') {
        updatedState.preferenceError.push('Paperless Billing');
      }  else if (preference.category === 'OUTG' && preference.messageType === 'OUTG') {
        updatedState.preferenceError.push('Repair and Maintenance Alerts');}
      else if (preference.category === 'OUTG' && preference.messageType === 'EMRG') {
      updatedState.preferenceError.push('Emergency Alerts');
      } });
    }
    updatedState.preferenceError = [...new Set(updatedState.preferenceError)];
    this.setState(updatedState);}
  removeHandler(e,email){
    const updatedState={...this.state};
    updatedState.emailErr=false, updatedState.removeButtonPress=true, updatedState.addIconPress=false,updatedState.editButtonPress=false,updatedState.removeEmail=email;
    this.getEnrollDetails(this.mainBpNumber,email),this.setState(updatedState);
  }
  //Delete button click functionality
  removeButtonHandler(e,sn){
    let reqObj={ "deviceType":"email","addressGuid":this.state.addressGuid,"modifiedValue": this.state.removeEmail, "sequenceNumber": sn};
    app.profileSettingsService.modifyCustomerPreference(this.mainBpNumber, reqObj, null, true).then(response => {
      if (response.errorCode && response.errorCode !== ''){
        this.setState({modifyError: true});
      }else{
        if(this.state.paperlessEnrolled){
          app.profileSettingsService.paperlessBillingDeEnroll(this.state.accountObj, app.appService.getUserInfo().profileData).then(
            (res) => {
              //de enrolled from pb
              });}
        this.refreshNotification();
        const updatedState = { ...this.state };
        updatedState.removeButtonPress=false, updatedState.paperlessEnrolled=false, updatedState.modifyError=false, this.setState(updatedState);
      } }); }
  editHandler(e,email,seqNo){ 
    window.aUtils.sendAAEvent("button","emailEdit");
    const updatedState = { ...this.state };
    updatedState.twoFactorAuthentication.seqNo=seqNo ,updatedState.editButtonPress = true, updatedState.editEmail=email, updatedState.newMail="",updatedState.emailExistErrMsg="", updatedState.addIconPress=false, updatedState.emailPrefErr=false,updatedState.isEmailInvalid=false,updatedState.modifyError=false, updatedState.disabledSave=false, this.setState(updatedState);
    this.getEnrollDetails(this.mainBpNumber,email);}
cancelButtonHandler = () => {
  const updatedState = { ...this.state };
  updatedState.cancelButtonPress = true,updatedState.editButtonPress = false,updatedState.emailExistErrMsg="",this.setState(updatedState);}
emailCallback(emailValue){
  const updatedState = { ...this.state };
  updatedState.enteredEmail=emailValue, updatedState.emailExistErrMsg="", 
  this.setState(updatedState,
    ()=>{this.validateEmail(this.state.enteredEmail);});}
newMailCallback(email,isNewEmailValid){
  const updatedState = { ...this.state };
  updatedState.inputEmail=email,updatedState.isNewEmailValid=isNewEmailValid, updatedState.addEmailExistErrMsg="";
  this.setState(updatedState,
  ()=>{this.validateEmail(this.state.inputEmail);});}
validateEmail(emailId){
  let emailVal=app.appUtil.isValidEmail(emailId);
  const updatedState = { ...this.state };
  if (emailVal) {
    updatedState.disabledSave=false,updatedState.disabledAdd=false,updatedState.isEmailInvalid=false,updatedState.editEmailInvalid=false,this.setState(updatedState);}
  else {
    updatedState.disabledSave=true,updatedState.disabledAdd=true,updatedState.isEmailInvalid=true,updatedState.editEmailInvalid=true,this.setState(updatedState);
  }}
addIconHandler(){
  const updatedState = { ...this.state };
  updatedState.addIconPress=true, updatedState.editButtonPress=false, updatedState.removeButtonPress=false,updatedState.addError=false, updatedState.addEmailExistErrMsg="", updatedState.disabledAdd=true, this.setState(updatedState);
}
getSequenceNumber(){
let seqNo="";
let oldEmail=this.state.editEmail;
    _.each(this.state.emailIds, function (record) {
      if(record.email.toLowerCase()===oldEmail.toLowerCase()) seqNo=record.sequenceNumber;
      });
      return seqNo; }
saveButtonHandler(){
  this.setState({disabledSave:true});
  window.aUtils.sendAAEvent("button","editEmailSave");
   const updatedState={...this.state};
  updatedState.oldEmailIds=this.state.emailIds;
let emailId=this.state.enteredEmail!=="" ? this.state.enteredEmail : this.state.editEmail;
if(!this.ifEmailExists(emailId)) {
  updatedState.modifyError = false, updatedState.editButtonPress = false, updatedState.addIconPress = false, updatedState.newMail = this.state.enteredEmail, updatedState.enteredEmail = "", updatedState.emailExistErrMsg = "", this.setState(updatedState);
  this.verifyHandler(this.state.enteredEmail, 'Email','U','',this.state.twoFactorAuthentication.seqNo);
}else{
  this.setState({emailExistErrMsg:this.strings.emailExistsErr});}}
addButtonHandler(){
  this.setState({disabledAdd:true,addError:false});
  window.aUtils.sendAAEvent("button","addEmail");
  const updatedState={...this.state};
if(!this.ifEmailExists(this.state.inputEmail)) {
      updatedState.editButtonPress = false, updatedState.addIconPress = false, updatedState.addEmailExistErrMsg = "", this.setState(updatedState);
      this.verifyHandler(this.state.inputEmail, 'Email','I','','');
}else{
  this.setState({addEmailExistErrMsg:this.strings.emailExistsErr});
}}
ifEmailExists(emailId) {
  let emailExist=false;
  _.each(this.state.emailIds, function (record) {
    if (record.email.toLowerCase() === emailId.toLowerCase())
      emailExist=true;});
    return emailExist;}
removeCancelHandler(){
  const updatedState={...this.state};
  updatedState.removeButtonPress=false, this.setState(updatedState);}
saveCancelButtonHandler(){
    const updatedState={...this.state};
    updatedState.saveCancelButtonPress=true, updatedState.addIconPress=false, updatedState.addEmailExistErrMsg="", updatedState.disabledAdd=true, this.setState(updatedState); }
  viewAllEmail(){
    window.aUtils.sendAAEvent("button","viewAllEmail");
    this.setState({viewAllMail:true}); }
  cancelViewAllMailButtonHandler(){
    this.setState({viewAllMail:false});
    this.refreshNotification();}
  viewAllVoice(){
    window.aUtils.sendAAEvent("button","viewAllVoice");
      this.setState({viewAllVoice:true});}
 cancelViewAllVoiceButtonHandler(){
      this.setState({viewAllVoice:false});
      this.refreshNotification();}
/* Formatting email ID with 4 stars */
 formatEmailIdWithStar = (emailId) => { return emailId.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c); }
      /* Assists to call TwoFactorAuth Container */
  verifyHandler = (value, showModal, changeFlag, encryptedvalue, sequenceNumber, phoneTypeSelectionEdit) => {
    const updatedState = { ...this.state };
    switch (showModal) {
      case 'Email': updatedState.twoFactorAuthentication.seqNo=sequenceNumber, updatedState.addIconPress=false,updatedState.editButtonPress=false,updatedState.twoFactorAuthentication.isEmail = true, updatedState.twoFactorAuthentication.userEnteredValue = value, updatedState.twoFactorAuthentication.showModal = showModal, updatedState.twoFactorAuthentication.changeFlag = changeFlag, updatedState.twoFactorAuthentication.bpNumber=this.mainBpNumber, this.setState(updatedState);
        break;
      case 'Phone': updatedState.twoFactorAuthentication.seqNo=sequenceNumber, updatedState.twoFactorAuthentication.isPhone = true, updatedState.twoFactorAuthentication.userEnteredValue = value, updatedState.twoFactorAuthentication.showModal = showModal, updatedState.twoFactorAuthentication.changeFlag = changeFlag, updatedState.twoFactorAuthentication.encryptedvalue = encryptedvalue,  updatedState.twoFactorAuthentication.phoneTypeSelectionEdit = phoneTypeSelectionEdit,updatedState.twoFactorAuthentication.bpNumber=this.mainBpNumber, updatedState.twoFactorAuthentication.duplicateNumber=updatedState.duplicatePhoneList.get(sequenceNumber), this.setState(updatedState);
        break;
      case 'ViewAllEmail': updatedState.twoFactorAuthentication.seqNo=sequenceNumber, updatedState.viewAllMail = false, updatedState.twoFactorAuthentication.isEmail = true, updatedState.twoFactorAuthentication.userEnteredValue = value, updatedState.twoFactorAuthentication.showModal = showModal, updatedState.twoFactorAuthentication.changeFlag = changeFlag,updatedState.twoFactorAuthentication.bpNumber=this.mainBpNumber, this.setState(updatedState);
        break;
      case 'ViewAllPhone': updatedState.twoFactorAuthentication.seqNo=sequenceNumber, updatedState.viewAllVoice = false, updatedState.twoFactorAuthentication.isPhone = true, updatedState.twoFactorAuthentication.userEnteredValue = value, updatedState.twoFactorAuthentication.showModal = showModal, updatedState.twoFactorAuthentication.changeFlag = changeFlag, updatedState.twoFactorAuthentication.encryptedvalue = encryptedvalue, updatedState.twoFactorAuthentication.phoneTypeSelectionEdit = phoneTypeSelectionEdit,updatedState.twoFactorAuthentication.bpNumber=this.mainBpNumber, updatedState.twoFactorAuthentication.duplicateNumber=updatedState.duplicatePhoneList.get(sequenceNumber), this.setState(updatedState);
        break;
      /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
      default: null;
          } }
  /* Assists to handle close icon fucntionality */
  handleCloseClick = (verified) => {
    let updatedState = { ...this.state };
    verified === "ok" ? window.aUtils.sendAAEvent("button","ok") : null;
    switch (updatedState.twoFactorAuthentication.showModal) {
      case 'Email':
        updatedState.twoFactorAuthentication.isEmail = false,updatedState.twoFactorAuthentication.bpNumber='', this.setState(updatedState);
        break;
      case 'Phone':
        updatedState.twoFactorAuthentication.isPhone = false,updatedState.twoFactorAuthentication.bpNumber='',updatedState.twoFactorAuthentication.duplicateNumber='', this.setState(updatedState);
        break;
      case 'ViewAllEmail':
        updatedState.twoFactorAuthentication.isEmail = false, updatedState.twoFactorAuthentication.isPhone = false, updatedState.viewAllMail = true,updatedState.twoFactorAuthentication.bpNumber='', this.setState(updatedState);
        break;
      case 'ViewAllPhone':
        updatedState.twoFactorAuthentication.isEmail = false, updatedState.twoFactorAuthentication.isPhone = false, updatedState.viewAllVoice = true,updatedState.twoFactorAuthentication.bpNumber='',updatedState.twoFactorAuthentication.duplicateNumber='', this.setState(updatedState);
        break;
      /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
      default: null;
         } }
     /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
    isLandlineOrMobile = (indicatorTelephone,isVerified) =>{
      switch(indicatorTelephone){
        case "2": 
        case "3": return isVerified ? this.strings.mobile : this.strings.mobileRadio;
        case "1": 
        case "": return isVerified ? this.strings.landline : this.strings.landlineRadio;
        default: return "";
     }  }
     overlayFocusController() {
      if(this.state.viewAllMail || this.state.viewAllVoice || this.state.twoFactorAuthentication.isPhone || this.state.twoFactorAuthentication.isEmail) {
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        document.body.style.position = this.initialPositionValue;
        document.body.style.removeProperty("width");
      }}
  render(){
    this.overlayFocusController();
  return (
      <div>
      {this.state.twoFactorAuthentication.isPhone || this.state.twoFactorAuthentication.isEmail ? <TwoFactorAuthContainer factors formatEmailIdWithStar={this.formatEmailIdWithStar}  twoFactorAuthentication={this.state.twoFactorAuthentication} handleCloseClick={this.handleCloseClick} addressGuid={this.state.addressGuid} refreshNotification={this.refreshNotification.bind(this)} /> : null}
      {this.state.viewAllMail ? <ViewAllEmail verifyHandler={this.verifyHandler} viewAllMail={this.state.viewAllMail} bpNumber={this.mainBpNumber} cancelViewAllMailButtonHandler={this.cancelViewAllMailButtonHandler.bind(this)} refreshLandingPage={this.refreshNotification.bind(this)}  /> : null}
      {this.state.viewAllVoice ? <ViewAllVoice verifyHandler={this.verifyHandler} bpNumber={this.mainBpNumber} cancelViewAllVoiceButtonHandler={this.cancelViewAllVoiceButtonHandler.bind(this)} refreshLandingPage={this.refreshNotification.bind(this)} isLandlineOrMobile={this.isLandlineOrMobile}  /> : null}
      <div className={classes.notificationcontainer}>
          <div className={classes.notificationLabel}>{this.strings.notificationLabel}</div>
          <p className={classes.add}> {this.strings.description} </p>
          <div className={classes.notifications}>
            {this.state.msCallErr ? <ErrorCard errorMsge={this.strings.msCallErrMsge} refresh={this.refreshNotification.bind(this)} /> :
              <div>
                <div className={classes.box}>
                  <div className={classes.row}>
                    <div className={classes.rowheader}>
                      <span> <img src={this.emailIcon} alt='Email Icon' /> </span>
                      <span className={classes.count}>{this.strings.email} ({this.state.emailIds.length})</span>
                      {this.state.emailIds.length > 3 ? <div className={classes.viewAllButtonPadding}><button className={classes.viewAllButton} id="viewAllEmail" onClick={this.viewAllEmail.bind(this)}  >{this.strings.viewall}</button></div> : null}
                    </div>
                    <div className={classes.dividerLine} />
                    <EmailPreferences verifyHandler={this.verifyHandler}  disabledSave={this.state.disabledSave} CACTCount={this.CACTCount} data={this.state} removeHandler={this.removeHandler.bind(this)} removeCancelHandler={this.removeCancelHandler.bind(this)} removeButtonHandler={this.removeButtonHandler.bind(this)} editHandler={this.editHandler.bind(this)} editButton={this.state.editButtonPress} editEmail={this.state.editEmail}
                      cancelButtonHandler={this.cancelButtonHandler.bind(this)} emailCallback={this.emailCallback.bind(this)} enteredEmail={this.state.enteredEmail} saveButtonHandler={this.saveButtonHandler.bind(this)}
                      emailExistErrMsg={this.state.emailExistErrMsg} modifyError={this.state.modifyError} totalAccounts={this.CACTCount} toolTipKeyPress={this.toolTipKeyPress.bind(this)} newMail={this.state.newMail} />
                    {this.state.addIconPress ?
                      <div>
                        <div className={classes.box}>
                          <span lassName={classes.textBox}>
                            <TextBox type='cenPrefEmail' maxLength={45} validator={app.appUtil.validator} placeholder={"Enter email"} newMailCallback={this.newMailCallback.bind(this)} emailValue={""} autoComplete="sceEmailProfile" />
                            <span className={classes.saveCancelButtonAlign}>
                              <button className={(this.state.disabledAdd) ? classes.disabledAddButtonEmail : classes.AddButtonEmail} onClick={this.addButtonHandler.bind(this)} disabled={this.state.disabledAdd}>{this.strings.AddButtonValue}</button>
                              <button className={classes.CancelButtonEmail} onClick={this.saveCancelButtonHandler.bind(this)}>{this.strings.CancelButtonValue}</button>
                            </span>
                          </span>
                          {this.state.addEmailExistErrMsg ? <span className={classes.errMsg}>{this.state.addEmailExistErrMsg}</span> : null}
                          {this.state.addError ? <span className={classes.errMsg}>{this.strings.errorMsg}</span> : null}
                          <div className={classes.dividerLine} /> </div></div> : null}
                    <div className={classes.adding}>
                      <button className={classes.addButton} onClick={this.addIconHandler.bind(this)}>
                        <img src={this.addIcon} alt='Add Icon' onClick={this.addIconHandler.bind(this)} /> &nbsp;
                <span className={classes.addnew}>{this.strings.addemail}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <NotificationVoiceSettings isLandlineOrMobile={this.isLandlineOrMobile} verifyHandler={this.verifyHandler} viewAllVoice={this.viewAllVoice.bind(this)} CACTCount={this.CACTCount} data={this.state} bpNumber={this.mainBpNumber} refreshNotification={this.refreshNotification.bind(this)} />
              </div>}
          </div>
        </div>     </div>);
  }
}
export default NotificationSettings;
